import auth from "./auth";
import common from "./common";
import users from "./users";
import usersRequests from "./usersRequests";
import audit from "./audit";
import groups from "./groups";
import theme from "./theme";
import assets from "./assets";
import routes from "./routes";
import params from "./params";
import functions from "./functions";
import localidade from "./localidade";
import files from "./files";
import biblioteca from "./biblioteca";
import paineis from "./paineis";
import control from "./control";
import job from "./job";
import jobNotifications from "./jobNotifications";
import databases from "./databases";
import fonte from "./fonte";
import datasets from "./datasets";
import regulamentos from "./regulamentos";

export default {
  auth,
  common,
  usersRequests,
  users,
  audit,
  groups,
  theme,
  assets,
  routes,
  params,
  functions,
  localidade,
  files,
  biblioteca,
  paineis,
  control,
  job,
  jobNotifications,
  databases,
  fonte,
  datasets,
  regulamentos,
};
